import { writable } from 'svelte/store';

export interface ConfirmationData {
    petitionId: number;
    petitionTitle: string;
    signatureCount?: number;
    signatureGoal?: number | null;
    shareUrl: string;
    facebookShareUrl?: string;
    twitterShareUrl?: string;
    linkedInShareUrl?: string;
    thankYouMessage: string;
    sharingEnabled: boolean;
    relatedPetitions: Array<{
        id: number;
        title: string;
        imageUrl: string | null;
        signatureCount: number;
        hasSigned?: boolean;
    }>;
    // Date when user previously signed (if they already signed before)
    datePreviouslySigned?: string | null;
}

// Store to pass confirmation data between SignPage and ConfirmationPage
export const confirmationData = writable<ConfirmationData | null>(null);

// Helper to set confirmation data before navigating
export function setConfirmationData(data: ConfirmationData) {
    confirmationData.set(data);
}

// Helper to clear confirmation data
export function clearConfirmationData() {
    confirmationData.set(null);
}

